/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useState, useCallback } from "react";
import { List, ListItem, ListItemText, ListSubheader, TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ConfirmDialog } from "../../../../components/ConfirmDialog/ConfirmDialog";
import { v2, errorToObject } from "@prftesp/cle-logger";
import { ForceCloseButton } from "./ForceCloseButton";

const QueueList = ({ queues, handleQueueSelected, selectedQueueId, formEdited, setIsLoading }) => {
	const [searchTerm, setSearchTerm] = useState("");
	const [editConfirmOpen, setEditConfirmOpen] = useState(false);
	const [queue, setQueue] = useState(undefined);
	const history = useHistory();

	const handleSearchChange = useCallback((e) => {
		setSearchTerm(e.target.value);
	}, []);

	const searchMatches = queues?.filter((x) => x.Name.toLowerCase().includes(searchTerm.toLowerCase())) || [];

	return (
		<div>
			<List
				component="nav"
				subheader={
					<ListSubheader disableSticky component="div">
						<div style={{ marginBottom: 8 }}>
							<TextField
								style={{ width: "100%" }}
								size="small"
								label="Search Queues"
								value={searchTerm}
								onChange={handleSearchChange}
							/>
						</div>
						<div className="d-flex flex-row justify-content-between align-items-center flex-wrap">
							<span>Queues</span>
							<ForceCloseButton setIsLoading={setIsLoading} />
						</div>
					</ListSubheader>
				}
			>
				{queues?.length && searchMatches.length > 0 ? (
					queues.map((queue) => {
						const searchMatch = searchMatches.find((s) => s.Id === queue.Id);
						return (
							<ListItem
								button
								selected={queue.Id === selectedQueueId}
								onClick={() => {
									setQueue(queue);
									formEdited ? setEditConfirmOpen(true) : handleQueueSelected(queue);
								}}
								key={queue.Id}
								style={{ display: searchMatch ? "flex" : "none" }}
							>
								<ListItemText style={{ overflowWrap: "break-word" }} primary={queue.Name} />
							</ListItem>
						);
					})
				) : (
					<ListItem>
						<span className="text-muted font-italic">
							{!searchTerm ? "No Queues yet, Add queues in Amazon Connect" : "No queues found."}
						</span>
					</ListItem>
				)}
			</List>
			<ConfirmDialog
				title={"Switch Queue?"}
				message={"You have unsaved changes that will be discarded if you proceed. Are you sure?"}
				confirmOpen={editConfirmOpen}
				onClose={async (confirmed) => {
					try {
						if (confirmed) {
							history.push(`./${queue.Id}`);
							handleQueueSelected(queue);
						}
						setEditConfirmOpen(false);
					} catch (error) {
						v2.error(`Error while cancelling canned response category.`, {
							additionalData: { error: errorToObject(error) },
						});
					}
				}}
			/>
		</div>
	);
};

export default QueueList;
